import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100px;
  margin-top: 0.75rem;
  border-radius: 4px;
  padding: 1rem;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  .info--{
    display: flex;
    .logo--{
      position: absolute;
      display: flex;
      width: 5rem;
      height: 5rem;
      top: -15px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .name--company{
      display: flex;
      width: 100%;
      max-height: 20px;
      margin-left: 5.5rem;
      flex-direction: column;
      span{
        display: flex;
        width: 100%;
        font-size: 1.3rem;
        font-weight: bolder;
        justify-content: left;
        align-items: center;
      }
    }
  }
  .full--{
    display: flex;
    justify-content: end;
    width: 100%;
    > span {
      position: absolute;
      right: 5px;
      top: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: .2rem;
      color: #1D86FF;
      border-radius: 4px;
      cursor: pointer;
      &:hover{
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
      }
    }
  }
  .--chart{
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    canvas{
      max-height: 400px;
    }
  }
`;